import ky from "ky";

import type { OngoingRequestsController } from "./types/OngoingRequestsController";
import type { Options } from "./types/Options";

export const makeMakeRequest =
  ({
    baseOptions = {},
    ongoingRequestsControllers,
  }: {
    baseOptions: Options;
    ongoingRequestsControllers: OngoingRequestsController;
  }) =>
  (url: string, options: Options) => {
    const controller = new AbortController();

    const { signal } = controller;

    const thisRequest = Symbol(url);

    ongoingRequestsControllers[thisRequest] = controller;

    Object.assign(options, baseOptions);

    options.signal ??= signal;

    options.hooks?.afterResponse?.push(() => {
      delete ongoingRequestsControllers[thisRequest];
    });

    const response = ky(url, options);

    return response;
  };
